// prettier-ignore
export const COLLECTIONS_EN_US_TRANSLATIONS = {
  'collectionsDomain.title': 'Merchandising Collections',
  'collectionsDomain.new.title': 'New Collection',
  'collectionsDomain.upc': 'UPC',
  'collectionsDomain.rrc': 'RRC',
  'collectionsDomain.cancel': 'Cancel',
  'collectionsDomain.noResults': 'No Results',
  'collectionsDomain.uploaded': 'Uploaded',
  'collectionsDomain.remove': 'Remove',
  'collectionsDomain.add': 'Add',

  // Create
  'collectionsDomain.breadcrumb.create': 'Create',
  // Edit
  'collectionsDomain.breadcrumb.edit': "Edit",
  // Delete
  'collectionsDomain.delete.title': 'Delete Collection?',
  'collectionsDomain.delete.text': 'Are you want to permanently delete {name} from your collections?',
  'collectionsDomain.delete.checkbox': 'Yes, I want to delete this collection',
  'collectionsDomain.delete.submit': 'Submit',
  'collectionsDomain.delete.error': 'An error occured while trying to delete the collection.',
  // List
  'collectionsDomain.list.title': 'Merchandising Collections',
  'collectionsDomain.list.columns.name.header': 'Collection Name',
  'collectionsDomain.list.columns.content.header': 'Content',
  'collectionsDomain.list.columns.status.header': 'Status',
  'collectionsDomain.list.columns.activeDates.header': 'Active Dates',
  'collectionsDomain.list.columns.lastUpdated.header': 'Last Updated',
  'collectionsDomain.list.filters.search': 'Search by collection name',
  'collectionsDomain.list.filters.source.default': 'Source',
  'collectionsDomain.list.filters.contentType.default': 'Content type',
  'collectionsDomain.list.status.default': 'Status',
  'collectionsDomain.list.status.active': 'Active',
  'collectionsDomain.list.status.inactive': 'Inactive',
  'collectionsDomain.list.activeDates.noStart': 'no start date',
  'collectionsDomain.list.activeDates.noEnd': 'no end date',
  'collectionsDomain.list.content.rules': '{count} rules',
  'collectionsDomain.list.content.children': '{count} child collections',
  'collectionsDomain.list.content.empty': 'Empty collection',
  'collectionsDomain.list.content.edit': 'Edit',
  // Detail
  'collectionsDomain.collectionsForm.section.details': 'Collection Details',
  'collectionsDomain.collectionsForm.section.details.name': 'Collection Name',
  'collectionsDomain.collectionsForm.section.details.parent.label': 'Parent Collection',
  'collectionsDomain.collectionsForm.section.details.applicableWarehouses.label': 'Applicable Warehouse',
  'collectionsDomain.collectionsForm.section.details.applicableWarehouses.applyToAll': 'Apply to all warehouses',
  'collectionsDomain.collectionsForm.section.details.parent.placeholder': 'No Parent Collection',
  'collectionsDomain.collectionsForm.section.details.date': 'Start date - end date (optional)',
  'collectionsDomain.collectionsForm.section.details.noEndDate': 'No end date',
  'collectionsDomain.collectionsForm.section.details.status.label': 'Status',
  'collectionsDomain.collectionsForm.section.details.status.active': 'Active',
  'collectionsDomain.collectionsForm.section.details.status.activeAdminOnly': 'Active (admin only)',
  'collectionsDomain.collectionsForm.section.details.status.inactive': 'Inactive',
  'collectionsDomain.collectionsForm.form.error.common': 'Form submission failed.',
  'collectionsDomain.collectionsForm.form.fields.name.error.required': 'Collection name is required.',
  'collectionsDomain.collectionsForm.form.fields.name.placeholder': 'Collection Name',
  // Tiles
  'collectionsDomain.collectionsForm.section.tiles': 'Tiles',
  'collectionsDomain.collectionsForm.section.tooltip.trigger': 'What does this look like?',
  'collectionsDomain.collectionsForm.section.tiles.tooltip.text': 'Tooltip content TBD',
  'collectionsDomain.collectionsForm.form.fields.tileImage.label': 'Tile image (89 x 89)',
  'collectionsDomain.collectionsForm.form.fields.tileImage.footnote': '.png, .jpg image only',
  'collectionsDomain.collectionsForm.form.fields.tileImage.error.required': 'Tile image is required.',
  'collectionsDomain.collectionsForm.section.tiles.toggleLabel': 'Add tile image',
  // Header
  'collectionsDomain.collectionsForm.section.header': 'Header',
  'collectionsDomain.collectionsForm.section.header.tooltip.text': 'Header tooltip content TBD',
  'collectionsDomain.collectionsForm.section.header.title': 'Title',
  'collectionsDomain.collectionsForm.section.header.title.error.required': 'Title is required.',
  'collectionsDomain.collectionsForm.section.header.displayStyle': 'Display style',
  'collectionsDomain.collectionsForm.section.header.displayStyle.graphics': 'Graphics Browser Header',
  'collectionsDomain.collectionsForm.section.header.displayStyle.hero': 'Hero Browser Header',
  'collectionsDomain.collectionsForm.section.header.displayStyle.browse': 'Browser Header',
  'collectionsDomain.collectionsForm.section.header.description.text': 'Description (optional)',
  'collectionsDomain.collectionsForm.section.header.description.placeholder': 'Description',
  'collectionsDomain.collectionsForm.section.header.color': 'Color',
  'collectionsDomain.collectionsForm.section.header.color.error.required': 'Color is required, eg. #FFFFFF',
  'collectionsDomain.collectionsForm.section.header.backgroundColor': 'Background Color',
  'collectionsDomain.collectionsForm.section.header.backgroundColor.error.required': 'Background Color is required',
  'collectionsDomain.collectionsForm.section.header.webHeader.label': 'Web header (1400 x 152)',
  'collectionsDomain.collectionsForm.section.header.webHeader.footnote': '.png, .jpg image only',
  'collectionsDomain.collectionsForm.section.header.webHeader.error.required': 'Web header image is required.',
  'collectionsDomain.collectionsForm.section.header.mobileHeader.label': 'Mobile header (400 x 140)',
  'collectionsDomain.collectionsForm.section.header.mobileHeader.footnote': '.png, .jpg image only',
  'collectionsDomain.collectionsForm.section.header.mobileHeader.error.required': 'Mobile header image is required.',
  'collectionsDomain.collectionsForm.section.header.toggleLabel': 'Show image header on collection page',
  // Storefront Banner
  'collectionsDomain.collectionsForm.section.storefrontBanner': 'Storefront Banner',
  'collectionsDomain.collectionsForm.section.storefrontBanner.display': 'Display',
  'collectionsDomain.collectionsForm.section.storefrontBanner.tooltip.text': 'Storefront tooltip content TBD',
  'collectionsDomain.collectionsForm.section.storefrontBanner.heading': 'Heading',
  'collectionsDomain.collectionsForm.section.storefrontBanner.heading.error.required': 'Heading is required',
  'collectionsDomain.collectionsForm.section.storefrontBanner.headingColor': 'Heading Color',
  'collectionsDomain.collectionsForm.section.storefrontBanner.headingColor.error.required': 'Heading color is required',
  'collectionsDomain.collectionsForm.section.storefrontBanner.subHeading': 'Sub heading',
  'collectionsDomain.collectionsForm.section.storefrontBanner.subHeading.error.required': 'Sub heading is required',
  'collectionsDomain.collectionsForm.section.storefrontBanner.subHeadingColor': 'Sub heading Color',
  'collectionsDomain.collectionsForm.section.storefrontBanner.subHeadingColor.error.required': 'Sub heading color is required',
  'collectionsDomain.collectionsForm.section.storefrontBanner.tag': 'Tag (optional)',
  'collectionsDomain.collectionsForm.section.storefrontBanner.tag.placeholder': 'Tag',
  'collectionsDomain.collectionsForm.section.storefrontBanner.tagColor': 'Tag Color (optional)',
  'collectionsDomain.collectionsForm.section.storefrontBanner.tagColor.placeholder': 'Tag color',
  'collectionsDomain.collectionsForm.section.storefrontBanner.cta': 'CTA',
  'collectionsDomain.collectionsForm.section.storefrontBanner.cta.error.required': 'CTA required',
  'collectionsDomain.collectionsForm.section.storefrontBanner.backgroundColor': 'Background Color (optional)',
  'collectionsDomain.collectionsForm.section.storefrontBanner.backgroundColor.placeholder': 'Background Color',
  'collectionsDomain.collectionsForm.section.storefrontBanner.bannerImage.label': 'Storefront banner (633 x 270)',
  'collectionsDomain.collectionsForm.section.storefrontBanner.bannerImage.footnote': '.png, .jpg image only',
  'collectionsDomain.collectionsForm.section.storefrontBanner.bannerImage.error.required': 'Storefront banner is required',
  'collectionsDomain.collectionsForm.section.storefrontBanner.toggleLabel': 'Add storefront banner',
  // Rules
  'collectionsDomain.collectionsForm.section.rules': 'Rules',
  'collectionsDomain.collectionsForm.section.rules.tooltip.text': 'Rules Tooltip content TBD',
  'collectionsDomain.collectionsForm.section.rules.searchTerm.placeholder': 'Search Term',
  'collectionsDomain.collectionsForm.section.rules.searchTerm.label': 'Rules Tooltip content TBD',
  'collectionsDomain.collectionsForm.section.rules.name.label': 'Display Name',
  'collectionsDomain.collectionsForm.section.rules.options.label': 'Select Rule',
  'collectionsDomain.collectionsForm.section.rules.options.searchTerm': 'Search Term',
  'collectionsDomain.collectionsForm.section.rules.options.upc': 'UPC',
  'collectionsDomain.collectionsForm.section.rules.options.productCodes': 'Product Codes',
  'collectionsDomain.collectionsForm.section.rules.action.addNewRule': 'Add New Rule',
  'collectionsDomain.collectionsForm.section.rules.productCodes.enterUpcs': 'Enter UPCs',
  'collectionsDomain.collectionsForm.section.rules.productCodes.enterRrcs': 'Enter RRCs',
  'collectionsDomain.collectionsForm.section.rules.productCodes.enterUpcs.header': 'Add Products By UPC',
  'collectionsDomain.collectionsForm.section.rules.productCodes.enterRrcs.header': 'Add Products By RRC',
  'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.matched': 'Matched {count} {count, plural, one {Product} other {Products}}',
  'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts': 'View Products',
  'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.header': 'Added Products',
  'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.table.product': 'Product',
  'collectionsDomain.collectionsForm.section.rules.productCodes.viewProducts.table.productCode': 'Product Code',
  'collectionsDomain.collectionsForm.section.rules.productCodes.codeTypeLabel': 'Code Type',
  'collectionsDomain.collectionsForm.section.rules.name.error.required': 'Rule name is required',
  // Form
  'collectionsDomain.collectionsForm.form.title.create': 'Create Collection',
  'collectionsDomain.collectionsForm.form.submit': 'Submit',
  'collectionsDomain.collectionsForm.form.validation.required': "This field is required",
  'collectionsDomain.collectionsForm.form.validation.default': "This field can't be blank.",
  // Child Collections
  'collectionsDomain.collectionsForm.section.childCollections.title': 'Child Collections',
  'collectionsDomain.collectionsForm.section.childCollections.addButton': 'Add child collection',
  'collectionsDomain.collectionsForm.section.selectCollectionModal.selectChild': 'Add Child Collection',
  'collectionsDomain.collectionsForm.section.selectCollectionModal.selectParent': 'Select Parent Collection',

  // Content
  'collectionsDomain.collectionsForm.content.title': 'Collection Content',
  'collectionsDomain.collectionsForm.content.type.rule': 'Rule Based',
  'collectionsDomain.collectionsForm.content.type.childCollections': 'Add Child Collections',

  // Form Custom Validations
  'collectionsDomain.collectionsForm.validation.treeStructure.error': 'Collection cannot have a parent and children',

  "collectionsDomain.addByUpc.header": "Adding Products by UPC",
  "collectionsDomain.addByUpc.description": "You can either type your UPC directly in the box or Copy and Paste them in. Make sure each UPC is separated from the next by a comma, space, or it is on a new line. Up to 5,000 UPCs can be uploaded at one time.",
  "collectionsDomain.addByUpc.textAreaPlaceholder": "Enter UPCs for the products you are selling separated by comma, space, or a new line",
  "collectionsDomain.addByUpc.submitAction": "Add UPCs",
  "collectionsDomain.addByUpc.submissionError": "Error occurred when adding UPCs, please try again.",
  "collectionsDomain.addByUpc.validationError.invalidCharacters": "UPCs should only contain numerical characters",
  "collectionsDomain.addByUpc.validationError.invalidLength": "UPCs should be 12 characters or less",
  "collectionsDomain.addByUpc.validationError.invalidTotalCount": "Only 5,000 UPCs can be uploaded at one time",
  "collectionsDomain.addByUpc.cancel": "Cancel",

  // View Page
  'collectionsDomain.view.header.detail': 'Collection Detail',
  'collectionsDomain.view.header.content': 'Collection Content',
  'collectionsDomain.view.header.tiles': 'Tiles',
  'collectionsDomain.view.header.header': 'Header',
  'collectionsDomain.view.header.storefrontBanner': 'Storefront Banner',
  'collectionsDomain.view.detail.name': 'Collection Name',
  'collectionsDomain.view.detail.slug': 'Identifier',
  'collectionsDomain.view.detail.activeDates': 'Active Dates',
  'collectionsDomain.view.detail.parentCollection': 'Parent Collection',
  'collectionsDomain.view.detail.applicableWarehouses': 'Applicable Warehouses',
  'collectionsDomain.view.header.title': 'Title',
  'collectionsDomain.view.header.displayStyle': 'Display Style',
  'collectionsDomain.view.header.description': 'Description',
  'collectionsDomain.view.header.color': 'Color',
  'collectionsDomain.view.header.backgroundColor': 'Background Color',
  'collectionsDomain.view.header.webHeader': 'Web Header',
  'collectionsDomain.view.header.mobileHeader': 'Mobile Header',
  'collectionsDomain.view.storefrontBanner.display': 'Display',
  'collectionsDomain.view.storefrontBanner.heading': 'Heading',
  'collectionsDomain.view.storefrontBanner.headingColor': 'Heading Color',
  'collectionsDomain.view.storefrontBanner.subHeading': 'Sub Heading',
  'collectionsDomain.view.storefrontBanner.subHeadingColor': 'Sub Heading Color',
  'collectionsDomain.view.storefrontBanner.tag': 'Tag',
  'collectionsDomain.view.storefrontBanner.tagColor': 'Tag Color',
  'collectionsDomain.view.storefrontBanner.cta': 'CTA',
  'collectionsDomain.view.storefrontBanner.backgroundColor': 'Background Color',
  'collectionsDomain.view.storefrontBanner.banner': 'Storefront Banner',
  'collectionsDomain.view.storefrontBanner.display.displayed': 'Displayed',
  'collectionsDomain.view.storefrontBanner.display.hidden': 'Hidden',
  'collectionsDomain.view.action.edit': 'Edit Collection',
  'collectionsDomain.view.action.delete': 'Delete Collection',
  'collectionsDomain.view.content.rule.searchTerm.label': 'Search term matches ',
  'collectionsDomain.view.content.rule.productCodes.label': 'Entered Product Code, includes',
  'collectionsDomain.view.content.rule.productCodes.count': '{count} {count, plural, one {Product} other {Products}}',

  'navCollectionsDomain.title': 'Navigation Collections',
  'navCollectionsDomain.list.title': 'Navigation Collections',
  'navCollectionsDomain.view.title': 'Navigation Collections - View',
} as const

export default COLLECTIONS_EN_US_TRANSLATIONS
